'use strict';
const connectorKey = require('@mindmup/mapjs-core/src/util/connector-key'),
	linkKey = require('@mindmup/mapjs-core/src/util/link-key');
module.exports = function findLine(line, parentContainer) {
	if (line && line.type === 'connector') {
		return parentContainer.querySelector('#' + connectorKey(line));
	} else if (line && line.type === 'link') {
		return parentContainer.querySelector('#' + linkKey(line));
	}
	console.log('invalid.line', line); //eslint-disable-line
	throw 'invalid-args';
};

